const setCurrentLegend = (state, payload) => {
  state.currentLegend = payload
}
const setAllLegend = (state, payload) => {
  state.allLegend = payload
}
const IncrementLegend = (state, payload) => {
  if (!state.allLegend.includes(payload)) {
    state.allLegend.push(payload)
  }
}
const DecrementLegend = (state, payload) => {
  state.allLegend = state.allLegend.filter((legend) => {
    if (legend !== undefined && legend.layerId !== payload) return legend
  })
}
const setEditLegend = (state, payload) => {
  state.editLegend = payload
}
const setLoadingLegend = (state, payload) => {
  state.loadingLegend = payload
}

export default {
  setLoadingLegend,
  setCurrentLegend,
  setAllLegend,
  IncrementLegend,
  DecrementLegend,
  setEditLegend
}
